
stateDefinitions = ($stateProvider) ->
    "ngInject"

    $stateProvider.state("program.amc_grant_report",
        url: '/amc-grant-report'
        abstract: true
        templateUrl: 'empty'
    )

    $stateProvider.state('program.amc_grant_report.index',
        url: ''
        permission: 'viewAmcGrantReport'
        templateUrl: 'programs/initiatives/amcGrantReport/index'
        resolve: grantReports: resovleGrantReports
        controllerAs: 'ctrl'
        controller: (@grantReports) ->
    )

    $stateProvider.state("program.amc_grant_report.view",
        url: '/{grant_year:int}'
        templateUrl: 'programs/initiatives/amcGrantReport'
        permission: 'viewAmcGrantReport'
        resolve:
            config: resolveConfig
            grantReport: resovleGrantReport
            data: resolveData

        controllerAs: 'ctrl'
        controller: 'AmcGrantReportController'
    )


### @ngInject ###
resolveConfig = ($http, $stateParams, ApiUrl, momentConvertFilter) ->
    url = ApiUrl("amc_grant_report/config", $stateParams.grant_year)
    $http.get(url).then((response) -> momentConvertFilter(response.data.item))

### @ngInject ###
resovleGrantReports = (ModelService, program) ->
    ModelService.getModelRelation(program, 'amc_grant_reports')

### @ngInject ###
resovleGrantReport = ($stateParams, program, ModelService) ->
    id = "#{program.id}/#{$stateParams.grant_year}"
    ModelService.get('amc_grant_report', id)

### @ngInject ###
resolveData = ($http, $stateParams, ApiUrl, program) ->
    url = ApiUrl('amc_grant_report', program.id, $stateParams.grant_year, 'data')
    return $http.get(url).then (response) -> response.data.item


module.config stateDefinitions
